import { List, ListItem, ListItemButton, ListItemText, Popover, styled } from "@mui/material";
import { MiscSavio, StyleguideSavioColors } from "../../../../configuration/themeSettings";
import { blue } from "@mui/material/colors";



;
export const StyledPopoverSortOrder = styled(Popover, {
    label: "FilterSearchSortOrderPopup",
})(({ theme }) => ({
    padding: "5px",
    maxHeight: "auto",

    border: "1px solid " + StyleguideSavioColors.lightGrey,
}));

export const StyledList = styled(List, {
    label: "FilterSearchSortOrderPopup-List",
})(({ theme }) => ({
    padding: 0,
    width: 300,
    maxWidth: 300,
    //marginBottom: 62,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    //overflowY: "auto",
    borderBottom: "1px solid " + StyleguideSavioColors.lightGrey,
}));

export const StyledListItem = styled(ListItem, {
    label: "FilterSearchSortOrderPopup-listItemCustom",
})(({ theme }) => ({
    borderBottomColor: StyleguideSavioColors.lightGrey,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    padding: 0,

    "&:last-child": {
        border: 0,
    },

    ".MuiListItemSecondaryAction-root": {
        display: "flex",
        alignItems: "center",
        svg: {
            fontSize: 28,
            cursor: "pointer",
        },
    },

    "&.selected": {
        backgroundColor: MiscSavio.hoverBackgroundTable,

        "&:hover > div":{
            "> div":{
                textDecoration: 'none !important',
            },

            "&:before":{
                display: 'none !important',
            }
        },

      

        "*": { color: "#fff", }
    },

    "&:not(.selected)":{
        "&:hover":{

            ".MuiButtonBase-root .MuiListItemText-root span":{
                color: StyleguideSavioColors.blue,
                textDecoration: 'underline'
            }
        }
    }
}));

export const StyledListItemButton = styled(ListItemButton, {
    label: "FilterSearchSortOrderPopup-listItemButtonCustom",
})(({ theme }) => ({
    margin: 0,
    paddingLeft: 13,
    paddingRight: 5,
    paddingBottom: 12,
    paddingTop: 12,

    "&:hover": {
        backgroundColor: 'inherit',
        "*": {  },
        "&:before": {
            display: 'block',
            content: "''",
            width: 3,
            height: '100%',
            backgroundColor: StyleguideSavioColors.blue,
            left: 0,
            position: 'absolute',


        }
    }


}));

export const StyledListItemText = styled(ListItemText, {
    label: "FilterSearchSortOrderPopup-ListItemText",
})(({ theme }) => ({
    paddingLeft: 5 + "px !important",
    span: {
        fontSize: 12,
        lineHeight: "14px",
        color: StyleguideSavioColors.text.black,
    },
}));